import z from "zod";
export var ChargingStationStatus;
(function (ChargingStationStatus) {
    ChargingStationStatus["AVAILABLE"] = "AVAILABLE";
    ChargingStationStatus["IN_USE"] = "IN_USE";
    ChargingStationStatus["MAINTENANCE"] = "MAINTENANCE";
    ChargingStationStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(ChargingStationStatus || (ChargingStationStatus = {}));
// Базовая схема для ChargingStation (общие поля)
export const zChargingStationCommonSchema = z.object({
    id: z.string(),
    idChargingStationModel: z.string(),
    serialNumber: z.string(),
    status: z.enum(ChargingStationStatus),
    manufactureDate: z.string().optional(),
    warrantyEndDate: z.string().optional(),
    lastMaintenanceDate: z.string().optional(),
    nextMaintenanceDate: z.string().optional(),
    totalChargingSessions: z.number().nullish(),
    totalKwhDelivered: z.number().nullish(),
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
    currentChargeLevel: z.number(),
});
export const zChargingStationFiltersSchema = z.object({
    search: z.string().optional(),
    status: z.enum(ChargingStationStatus).optional(),
});
